module.exports = __webpack_public_path__ + "static/media/SIR_logo_Black.e25ae7b6df.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/SIR_logo_Black.png
// module id = 6423
// module chunks = 0